/**
 * The snapping buffer allowed between 2 elements
 * @type {Number}
 */
const SNAPPING_BUFFER = 20;

module.exports = {
    SNAPPING_BUFFER
};
